// Politique des mots de passe — miroir de `check_password_strength`
// (app/schemas/user.py). C'est le back qui fait foi ; ici on affiche la check-list.
//
// « Caractère spécial » = tout ce qui n'est ni lettre, ni chiffre, ni espace. Une liste
// fermée (`!@#$%…`) refusait les mots de passe générés par les gestionnaires qui
// puisent dans `~ ' " \ €`…, sans que la personne comprenne pourquoi.

export function validatePassword(password = '') {
  return {
    length: password.length >= 8,
    uppercase: /\p{Lu}/u.test(password),
    digit: /\p{Nd}/u.test(password),
    special: /[^\p{L}\p{N}\s]/u.test(password),
  };
}

export const isPasswordValid = (password) =>
  Object.values(validatePassword(password)).every(Boolean);

export const PWD_RULES = [
  { key: 'length',    label: 'au moins 8 caractères' },
  { key: 'uppercase', label: 'au moins une majuscule' },
  { key: 'digit',     label: 'au moins un chiffre' },
  { key: 'special',   label: 'au moins un caractère spécial (!@#$%…)' },
];

// Attribut `passwordrules` (Safari / trousseau iCloud) : le mot de passe fort proposé
// par l'iPhone respecte alors d'emblée la politique, au lieu d'être refusé au submit.
export const PASSWORD_RULES_ATTR =
  'minlength: 8; required: lower; required: upper; required: digit; required: [-!@#$%^&*_+=?];';
